<script lang="ts">
    export let href: string;
    export let isDisabled = false;
    export let showWhen = true;
</script>

<template>
    {#if showWhen}
        <li role="menuitem" class:disabled={isDisabled}>
            <a href={href}>
                <slot></slot>
            </a>
        </li>
    {/if}
</template>